export const en = {
    appTitle: `Account Management`,
    loading: `Loading...`,
    emailLabel: `Email`,
    emailPlaceholder: `Enter your email`,
    passwordLabel: `Password`,
    passwordPlaceholder: `Enter your password`,
    firstNameLabel: `First name`,
    firstNamePlaceholder: `First name`,
    lastNameLabel: `Last name`,
    lastNamePlaceholder: `Last name`,
    confirmPasswordLabel: `Confirm password`,
    confirmPasswordPlaceholder: `Confirm password`,
    currentPasswordLabel: `Current password`,
    currentPasswordPlaceholder: `Current password`,
    newPasswordLabel: `New password`,
    newPasswordPlaceholder: `New password`,
    confirmNewPasswordLabel: `Confirm new password`,
    confirmNewPasswordPlaceholder: `Confirm new password`,
    resetTokenLabel: `Reset Token`,
    resetTokenPlaceholder: `Reset token`,
    serverError: `The server is currently experiencing issues. Please try again later or contact support if the problem persists.`,
    networkError: `Unable to connect to the server. Please check your internet connection and try again.`,
    passwordsDoNotMatch: `Passwords do not match`,
    supportContact: `For support, contact:`,
    backToLogin: `Back to login`,
    backToSignIn: `Back to Sign In`,
    signIn: `Sign In`,
    signUp: `Sign up`,
    createAccount: `Create Account`,
    continueToSignIn: `Continue to Sign In`,
    continueNow: `Continue Now`,
    createNewAccount: `Create New Account`,
    invalidConfirmationLink: `Invalid confirmation link. Please check your email for the correct link.`,
    pleaseFillAllFields: `Please fill in all fields`,
    redirectNow: `Redirect now`,
    cancel: `Cancel`,
    redirecting: `Redirecting...`,
    cancelAction: `cancel`,
    toggleTheme: `Toggle theme`,
    language: `Language`,
    languageAuto: `Auto`,
    languageEn: `English`,
    languageEs: `Español`,
    languagePt: `Português`,
    providerGoogle: `Google`,
    providerMicrosoft: `Microsoft`,
    providerFacebook: `Facebook`,
    providerGithub: `GitHub`,
    signInWith: `Sign in with {provider}`,
    redirectProgressAria: `Redirect progress`,
    redirectingToResendConfirmationEmail: `Redirecting to resend confirmation email...`,
};
//# sourceMappingURL=en.js.map